import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, Form, Row, Select, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import Title from 'antd/lib/typography/Title';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  .ant-table table {
    font-size: 14px;
  }
  .ant-table-tbody > tr > td {
    height: 5px;
    padding: 4px;
  }
  /* row tags */
  .my-tag {
    font-size: 12px;
  }
  .ant-table-thead > tr > th {
    height: 5px;
    padding: 4px;
  }
  .ant-table-summary > tr > td {
    height: 5px;
    padding: 4px;
  }
`;

const { Option } = Select;

interface WorkRecordStatComponentProps {
  data: any;
}

function WorkRecordStatComponent({ data }: WorkRecordStatComponentProps) {
  const [form] = Form.useForm();
  const [gongjongListOptions, setGongjongListOptions] = useState<any[]>();
  const [companyListOptions, setCompanyListOptions] = useState<any[]>();
  const [workRecordList, setWorkRecordList] = useState<any[]>(data.workRecords);
  const [jigjongListOptions, setJigjongListOptions] = useState<any[]>();

  useEffect(() => {
    let children: any = [];
    let index = 0;
    for (const gongjong of data.gongjongList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={index} value={gongjong.name}>
          {gongjong.name}
        </Option>,
      );
      index++;
    }
    setGongjongListOptions(children);

    children = [];
    index = 0;
    for (const gongjong of data.companyList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={index} value={gongjong.name}>
          {gongjong.name}
        </Option>,
      );
      index++;
    }
    setCompanyListOptions(children);

    children = [];
    index = 0;
    for (const jigjong of data.jigjongList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={index} value={jigjong.name}>
          {jigjong.name}
        </Option>,
      );
      index++;
    }
    setJigjongListOptions(children);
  }, [data]);

  const onSearch = (values: any) => {
    console.log(values);
    // const _workRecordList = data.workRecords
    //   .filter(
    //     (record: any) =>
    //       values.gongjong !== undefined && values.gongjong === record.gongjong,
    //   )
    //   .filter(
    //     (record: any) =>
    //       values.company !== undefined && values.company === record.name,
    //   );
    // console.log(_workRecordList);

    // setWorkRecordList(
    //   // data.workRecords.filter((record: any) => {
    //   //   if (values.gongjong && values.company) {
    //   //     return (
    //   //       record.gongjong === values.gongjong &&
    //   //       record.name === values.company
    //   //     );
    //   //   } else if (values.gongjong) {
    //   //     return record.gongjong === values.gongjong;
    //   //   } else if (values.company) {
    //   //     return record.name === values.company;
    //   //   }
    //   //   return record;
    //   // }),
    //   _workRecordList,
    // );
    setWorkRecordList(
      data.workRecords.filter((record: any) => {
        if (values.gongjong && values.company && values.jigjong) {
          return (
            record.gongjong === values.gongjong &&
            record.name === values.company &&
            record.jigjong === values.jigjong
          );
        } else if (values.gongjong && values.company) {
          return (
            record.gongjong === values.gongjong &&
            record.name === values.company
          );
        } else if (values.gongjong && values.jigjong) {
          return (
            record.gongjong === values.gongjong &&
            record.jigjong === values.jigjong
          );
        } else if (values.company && values.jigjong) {
          return (
            record.name === values.company && record.jigjong === values.jigjong
          );
        } else if (values.gongjong) {
          return record.gongjong === values.gongjong;
        } else if (values.company) {
          return record.name === values.company;
        } else if (values.jigjong) {
          return record.jigjong === values.jigjong;
        }
        return record;
      }),
    );
  };

  const columns: ColumnsType<any> = [
    {
      title: '날짜',
      dataIndex: 'createdDate',
      width: '10%',
    },
    {
      title: '공종',
      dataIndex: 'gongjong',
      align: 'center',
      width: '15%',
    },
    {
      title: '회사명',
      dataIndex: 'name',
      align: 'center',
      width: '15%',
    },
    {
      title: '직종',
      dataIndex: 'jigjong',
      align: 'center',
      width: '15%',
    },
    {
      title: '공수',
      dataIndex: 'numOfGongsu',
      align: 'center',
      width: '10%',
    },
    {
      title: '작업자수(명)',
      dataIndex: 'numOfWorkers',
      align: 'center',
      width: '10%',
    },
    {
      title: '공수합계',
      // dataIndex: 'numOfGongsu',
      align: 'center',
      width: '10%',
      render: (text, record, index) => {
        return record.numOfGongsu * record.numOfWorkers;
      },
    },
  ];

  console.log(data);

  return (
    <StyledDiv>
      <Row>
        <Col>
          <Title level={3}>작업일보 통계</Title>
        </Col>
      </Row>
      <Row style={{ height: '95%' }}>
        <Col span={19}>
          {workRecordList && (
            <Table<any>
              rowKey="id"
              columns={columns}
              dataSource={workRecordList}
              pagination={false}
              summary={(pageData) => {
                let totalNumOfWorkers = 0;
                let totalSumOfGongsu = 0;

                pageData.forEach(({ numOfWorkers, numOfGongsu }) => {
                  totalNumOfWorkers += numOfWorkers;
                  totalSumOfGongsu += numOfWorkers * numOfGongsu;
                });
                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0}></Table.Summary.Cell>
                      <Table.Summary.Cell index={1}></Table.Summary.Cell>
                      <Table.Summary.Cell index={1}></Table.Summary.Cell>
                      <Table.Summary.Cell index={1}></Table.Summary.Cell>
                      <Table.Summary.Cell index={2} align="right">
                        Total:
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={4} align="center">
                        {totalNumOfWorkers}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={4} align="center">
                        {totalSumOfGongsu}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
          )}
        </Col>
        <Col
          span={5}
          style={{
            border: '2px solid #bcbcbc',
            padding: '5px',
            height: '500px',
          }}
        >
          <Form
            form={form}
            name="advanced_search"
            layout="vertical"
            size="small"
            onFinish={onSearch}
          >
            <Row
              justify={'center'}
              style={{ marginTop: '10px', marginBottom: '10px' }}
            >
              <Button
                htmlType="submit"
                icon={<SearchOutlined rev={undefined} />}
                style={{ width: '60%' }}
              >
                검색
              </Button>
            </Row>

            <Form.Item name="gongjong" label="공종">
              <Select style={{ width: '100%' }} allowClear>
                {gongjongListOptions}
              </Select>
            </Form.Item>
            <Form.Item name="company" label="회사명">
              <Select style={{ width: '100%' }} allowClear>
                {companyListOptions}
              </Select>
            </Form.Item>
            <Form.Item name="jigjong" label="직종">
              <Select style={{ width: '100%' }} allowClear>
                {jigjongListOptions}
              </Select>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </StyledDiv>
  );
}

export default WorkRecordStatComponent;
